module.exports = Song;

function Song(json) {
	this.title = null;
	this.showId = null;
	this.showTitle = null;
	this.showSortTitle = null;
	this.composers = [];
	this.lyricists = [];
	this.tags = [];
	this.popularity = null;
	
	//Note: this field should only be used if the Wikipedia URL for the song
	//is different from the URL for the show (e.g. compilation shows or standalone songs)
	//this.wikipediaUrl = null;

	//ID of the user who entered this song into the database, and ID of last user to update it
	this.enteredById = null;
	this.lastUpdatedById = null;

	//TODO should required fields like yearWritten be included here?
	//Maybe only for text fields and not boolean fields like isComic...
	
	//Defaults for external links
	this.externalLinks = {
		scores: {
			musicNotes: {
				id: 'musicNotes'
			  , siteName: 'MusicNotes.com'
			  , enabled: true
			  , automatic: true
			  , includeSongTitle: true  //include song title in automatic search by default
			  
			  //Note: for manual links, there will be a 'url' field here
			}
		  , sheetMusicPlus: {
		  		id: 'sheetMusicPlus'
		  	  , siteName: 'SheetMusicPlus.com'
			  , enabled: true
			  , automatic: true
			  , includeSongTitle: true
			}
		  , newMusicalTheatre: {
		  		id: 'newMusicalTheatre'
		  	  , siteName: 'NewMusicalTheatre.com'
			  , enabled: false
			  , automatic: false
			}
		  , amazon: {
		  		id: 'amazon'
		  	  , siteName: 'Amazon.com'
		  	  , enabled: true
		  	  , automatic: true
		  	}
		  , worldcat: {
				id: 'worldcat'
			  , siteName: 'WorldCat (library holdings)'
			  , enabled: true
			  , automatic: true
			}
		  , contemporaryMusicalTheatre: {
				id: 'contemporaryMusicalTheatre'
			  , siteName: 'ContemporaryMusicalTheatre.com'
			  , enabled: false
			  , automatic: false
			}
		}
	  , recordings: {
		    amazon: {
		  		id: 'amazon'
		  	  , siteName: 'Amazon.com'
		  	  , enabled: true
		  	  , automatic: true
		  	}
		  , iTunes: {
		  		id: 'iTunes'
		  	  , siteName: 'iTunes'
		  	  , enabled: true
		  	  , automatic: true
		  	}
		  , spotify: {
		  		id: 'spotify'
		  	  , siteName: 'Spotify'
		  	  , enabled: true
		  	  , automatic: true
		  	  , includeSongTitle: true  //include song title in automatic search by default
		  	}
		  , soundCloud: {
		  		id: 'soundCloud'
		  	  , siteName: 'SoundCloud'
		  	  , enabled: false
		  	  , automatic: false
			}
		  , newMusicalTheatre: {
		  		id: 'newMusicalTheatre'
		  	  , siteName: 'NewMusicalTheatre.com'
			  , enabled: false
			  , automatic: false
			}
		  , worldcat: {
				id: 'worldcat'
			  , siteName: 'WorldCat (library holdings)'
			  , enabled: true
			  , automatic: true
			}
		  , contemporaryMusicalTheatre: {
				id: 'contemporaryMusicalTheatre'
			  , siteName: 'ContemporaryMusicalTheatre.com'
			  , enabled: false
			  , automatic: false
			}
		  , gsarchive: {
				id: 'gsarchive'
			  , siteName: 'The Gilbert & Sullivan Archive'
			  , enabled: false
			  , automatic: false
			}
		}
	};
	
	if (json) {
		for (var propName in json) {
			this[propName] = json[propName];
		}
	}
}

Song.getExternalLinkBaseSearchUrls = function() {
	var baseUrls = {
		scores: {
			'amazon': 'http://www.amazon.com/s/ref=nb_sb_noss_2?url=search-alias%3Daps&tag=musicalcom0b-20&' // Associates ID (affiliate link)
				+ 'field-keywords=%22sheet+music%22+'
		  , 'musicNotes': 'http://search.musicnotes.com/?q='
		  , 'sheetMusicPlus': 'http://www.sheetmusicplus.com/search?Ntt='
		  , 'newMusicalTheatre': 'http://newmusicaltheatre.com/catalogsearch/result/?q='
		  , 'worldcat': 'http://www.worldcat.org/search?qt=affiliate&ai=Musical_musicaltheatersongs&fq=x0%3Amsscr&q=ti%3A'
		  , 'contemporaryMusicalTheatre': 'https://www.contemporarymusicaltheatre.com/'
		}
	  , recordings: {
			'amazon': 'http://www.amazon.com/s/ref=nb_sb_noss_2?url=search-alias%3Daps&tag=musicalcom0b-20&' // Associates ID (affiliate link)
				+ 'field-keywords=music+'
			//Note: iTunes redirects to http://search.itunes.apple.com/WebObjects/MZContentLink.woa/wa/link?path=
			//Leaving it as itunes.com in case that ever changes...
		  , 'iTunes': 'http://itunes.com/'
		  , 'spotify': 'https://play.spotify.com/search/'
		  , 'newMusicalTheatre': 'http://newmusicaltheatre.com/catalogsearch/result/?q='
		  , 'worldcat': 'http://www.worldcat.org/search?qt=affiliate&ai=Musical_musicaltheatersongs&fq=x0%3Amusic&q=ti%3A'
		  , 'contemporaryMusicalTheatre': 'https://www.contemporarymusicaltheatre.com/'
		  , 'gsarchive': 'http://search.freefind.com/find.html?id=2743017&pid=r&mode=ALL&n=0&submit=+Find%21+&query='
		}
	};
	return baseUrls;
	
	/*
	//Affiliate links
	for (var category in baseUrls) {
		var catLinks = baseUrls[category];
		for (var linkId in catLinks) {
			switch (linkId) {
				case 'amazon':
					catLinks[linkId] += 'tag=musicalcom0b-20&'
					break;
			}
		}
	}
	*/
}
